import React from 'react'

import { VStack } from 'govwell-ui'
import { AIChatSessionFragment } from 'types/graphql'

import AIChatDisplay from 'src/pages/AIAssistantHistoryPage/AIChatDisplay'
import { RefetchFnType } from 'src/types'

type Props = {
  session: AIChatSessionFragment
  refetch: RefetchFnType
}

const AISessionDisplay = ({ session: { chats }, refetch }: Props) => {
  return (
    <VStack gap={1}>
      {chats?.map((c, index) => (
        <AIChatDisplay key={c.id} chat={c} index={index} refetch={refetch} />
      ))}
    </VStack>
  )
}

export default React.memo(AISessionDisplay)
